// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select {
  height: 37px;
  width: 100%;
  border: none;
  outline: none;
  background-color: #f0f0f0;
  background: #f0f0f0;
  margin-bottom: 9px;
  padding-left: 10px;
  box-sizing: border-box;
}

select option {
  color: #777b7e;
  background-color: white;
  height: 37px;
  outline: 0;
}

.field {
  margin: 8px 16px;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/search-field/search-field.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,cAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;AACJ;;AAEA;EACI,gBAAA;AACJ","sourcesContent":["select {\n    height: 37px;\n    width: 100%;\n    border: none;\n    outline: none;\n    background-color: #f0f0f0;\n    background: #f0f0f0;\n    margin-bottom: 9px;\n    padding-left: 10px;\n    box-sizing: border-box;\n}\n\nselect option {\n    color: #777b7e;\n    background-color: white;\n    height: 37px;\n    outline: 0;\n}\n\n.field {\n    margin: 8px 16px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
